import styled from 'styled-components';

import { basicSmallTextStyle } from '@dreryk/react-components';

export const StyledGuardianCellPesel = styled.div`
   ${basicSmallTextStyle}
`;
StyledGuardianCellPesel.displayName = 'StyledGuardianCellPesel';
